import {LinkOutlined} from '@ant-design/icons'
import React, {useState} from 'react'
import {Button, Tooltip} from 'antd'

interface Props {
    text: string
}

export const CopyToClipboardButton: React.FC<Props> = ({text}) => {
    const [copied, setCopied] = useState(false);

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(text);
            setCopied(true);
            setTimeout(() => setCopied(false), 1500);
        } catch (err) {
            console.error("Failed to copy:", err);
        }
    };

    return (
        <Tooltip title={copied ? "Copied!" : "Copy to clipboard"}>
        <Button
            onClick={handleCopy}
        >
            <LinkOutlined />
        </Button>
        </Tooltip>
    )
}